<ng-container>
	<div class="modal-header">
		<h1 class="modal-title" [translate]="operation?.kind === 'demandeRib' ? 'Labels.DemandeRib' : 'Labels.Ope'"></h1>
		<button type="button" class="modal-button-close fal fa-times" (click)="onClose()"></button>
	</div>
	<div class="modal-body">
		<ng-container *ngIf="operation">
			<h2>{{ operation?.montant| amount }}  {{ ' ' + getDevise(operation) + ' - ' + operation?.emetteurBeneficiaire }}</h2>
		</ng-container>
		<commentaires-history [affaireId]="operation?.affaireId" [operationId]="operation?.operationId"> </commentaires-history>
		<ng-container>
			<label class="form-label" translate="Labels.Motif"></label>
			<br />
			<span class="text-libre-comments-metadata-motif"> {{ operation?.sousMotif?.libelle }}</span>
		</ng-container>
		<br />
		<br />
		<commentaires-form (action)="action.emit($event)" [operation]="operation"></commentaires-form>
	</div>
	<div class="modal-footer"></div>
</ng-container>
